<template lang="pug">
  .section-units
    template(v-if="course.units")
      p(v-if="!course.units.length").text-center Темы еще не добавлены...
      v-row(v-else)
        v-col(
          v-for="(unit, idx) in course.units" cols="6"
          :key="idx"
          :class="!isMobile ? 'px-16' : ''"
        )
          v-card.sdo-card.mt-2(height="100%")
            v-card-text.d-flex.flex-column
              v-chip(
                style="position: absolute; right: -3px; top: 0" right="0"
                color="secondary" small
              ): strong {{ idx + 1 }}
              p.text-body-1.mb-0 {{ unit.title }}
              v-spacer
              .text-body-2: strong {{ $tc('hours', unit.duration) }}

</template>

<script>
export default {
  props: {
    course: { type: Object, required: true },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
  },
};
</script>
